import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const ArrowUp = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.9975 2C11.8277 2 11.6678 2.07 11.5579 2.19L3.17493 10.94C2.93513 11.19 2.94512 11.58 3.18492 11.82C3.42472 12.06 3.8144 12.05 4.05419 11.81L11.3781 4.17V21.37C11.3781 21.71 11.6578 22 11.9975 22C12.3373 22 12.617 21.72 12.617 21.38V4.17L19.9409 11.81C20.1807 12.06 20.5704 12.06 20.8102 11.82C20.9301 11.7 21 11.53 21 11.37C21 11.21 20.9401 11.06 20.8301 10.93L12.4372 2.19C12.3273 2.07 12.1674 2 11.9975 2Z" />
  </svg>
)

export default withDefaultStyles(ArrowUp)
